import {objects} from "../objects.js";
import './css/ObjectsPage.css'
import {useEffect, useState} from "react";

export const ObjectsPage = (props) => {
    useEffect(() => {
        props.onEnter();
    }, []);

    const [selected, setObject] = useState('')

    const objectContainer = [];
    for (const objectsKey in objects) {
        objectContainer.push(
            <div key={objectsKey}>
                <h2 onClick={() => {
                    if (selected === objectsKey) {
                        setObject('')
                    } else {
                        setObject(objectsKey)
                    }
                }}>{objectsKey}</h2>
                {selected === objectsKey &&
                    <div className="object-fields">
                        <pre>{JSON.stringify(objects[objectsKey], null, 2)}</pre>
                    </div>}
                <hr/>
            </div>
        );
    }

    return (
        <div className="main-container">
            <div className="fields-container">
                {objectContainer}
            </div>
        </div>)
}